import { useEffect, useState } from "react";
import { Inbox, Images } from "lucide-react";
import AdminLogin from "../components/AdminLogin";
import AdminInbox from "../components/AdminInbox";
import AdminGallery from "../components/AdminGallery";
import { Seo } from "../components/Seo";
import { api } from "../lib/api";

const TABS = [
    { key: "quotes", label: "Quote inbox", icon: Inbox },
    { key: "gallery", label: "Job photos", icon: Images },
];

const Admin = () => {
    const [user, setUser] = useState(null); // null = checking, false = signed out
    const [tab, setTab] = useState("quotes");

    useEffect(() => {
        api.get("/auth/me")
            .then(({ data }) => setUser(data))
            .catch(() => setUser(false));
    }, []);

    return (
        <main className="bg-brand-ink min-h-screen">
            <Seo title="Owner login" description="Private owner area for Southeast Stump Grinding." noindex />
            <section className="max-w-5xl mx-auto px-5 sm:px-8 pt-40 pb-24">
                {user === null && (
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-moss" data-testid="admin-checking">
                        Checking session...
                    </p>
                )}
                {user === false && <AdminLogin onSuccess={setUser} />}
                {user && (
                    <>
                        <div className="flex gap-2 mb-10 border-b border-brand-line" data-testid="admin-tabs">
                            {TABS.map(({ key, label, icon: Icon }) => (
                                <button
                                    key={key}
                                    onClick={() => setTab(key)}
                                    data-testid={`admin-tab-${key}`}
                                    className={`inline-flex items-center gap-2 px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] border-b-2 -mb-px transition-colors ${
                                        tab === key
                                            ? "border-brand-amber text-brand-amber"
                                            : "border-transparent text-brand-sage hover:text-brand-cream"
                                    }`}
                                >
                                    <Icon className="w-4 h-4" />
                                    {label}
                                </button>
                            ))}
                        </div>
                        {tab === "quotes" ? (
                            <AdminInbox user={user} onLogout={() => setUser(false)} />
                        ) : (
                            <AdminGallery />
                        )}
                    </>
                )}
            </section>
        </main>
    );
};

export default Admin;
